export enum OrderStatus {
  Initiated = 'INITIATED',
  Failed = 'FAILED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETE'
}
